// HackerNoon Pixel Icon Library iconfont (hn-* classes). CSS import handled
// by Vite at bundle time; this project has no *.css module declaration, so
// suppress the unresolved-module error until one is added to global.d.ts.
// @ts-ignore
import '@hackernoon/pixel-icon-library/fonts/iconfont.css';
import { Game } from './game.js';

const canvas = document.getElementById('game-canvas') as HTMLCanvasElement | null;
const unsupported = document.getElementById('unsupported');

if (!canvas) {
  throw new Error('game-canvas not found');
}

const gl = canvas.getContext('webgl2');
if (!gl) {
  if (unsupported) unsupported.style.display = 'flex';
  throw new Error('WebGL2 not supported');
}

const game = new Game(canvas);
game.start();
(window as any).game = game;

window.addEventListener('beforeunload', () => {
  game.dispose();
});
